<template>
  <div class="sku-select" v-if="spuInfo">
    <SkuProduct
      :spuInfo="spuInfo"
      :skuInfo="skuInfo"
      :discountType="discountType"
      :source="source"
      :checkedInfo="checkedInfo"
      :totalPrice="totalPrice"
      :number="number"
      :suiteId="suiteId"
      :service="service"
      :fqNum="fqNum"
      :params="params"
      :spotEstimatedPrice="spotEstimatedPrice"
      @clickTrack="clickTrack"
    />

    <div class="sku_content">
      <!-- 购买方式 支持换新的前提下 -->
      <SkuBuyType
        v-if="!hideBuyType && showRecycleBuyType && source != 20 && source != 21"
        @typeChange="buyTypeChange"
        :type="buyType"
      />
      <!-- 规格 -->
      <SkuSpec
        ref="skuSpecRef"
        :spuInfo="spuInfo"
        :skuInfo="skuInfo"
        :specMain="spuInfo.specItem.specMain"
        :specMainSeq="spuInfo.specItem.specMainSeq"
        :skuSpecList="spuInfo.specItem.skuSpecList"
        :specItemSeq="spuInfo.specItem.specItemSeq"
        :defaultSkuId="spuInfo.defaultSkuId"
        :skuId="skuId"
        @specChange="specChange"
      />

      <!-- 镭雕 拼团不显示镭雕 以旧换新不支持镭雕 虚拟商品不支持镭雕(产品确认过虚拟商品不配镭雕活动)-->
      <SkuLaser
        v-if="laserInfo && !isGroup && source != 20 && source != 21 && buyType != 2"
        :checked="laser"
        :tips="laserInfo.laserDesc"
        @laserChange="laserChange"
      />

      <!-- 数量 -->
      <SkuNumber :spuInfo="spuInfo" :enableInput="enableNumInput" :skuInfo="skuInfo" :number="number" :maxNum="maxNum" @numberChange="numberChange" />

      <!-- 套餐 拼团不显示套餐 -->
      <SkuSuite
        v-if="!isGroup && suites && suites.length"
        :skuInfo="skuInfo"
        :suites="suites"
        :currentSuite="currentSuite"
        @suiteChange="suiteChange"
      />

      <!-- 服务 -->
      <SkuService
        v-if="spuInfo.commoditySvcs && spuInfo.commoditySvcs.length"
        :service="spuInfo.commoditySvcs"
        :checkedService="service"
        @serviceChange="serviceChange"
      />

      <!-- 分期 -->
      <SkuInstallment
        v-if="installment && discountType != 'deposit' && salePrice !== 999999"
        :skuId="skuId"
        :money="totalPrice"
        :fqType="fqType"
        :fqNum="fqNum"
        :installment="installment"
        @fqTypeChange="fqTypeChange"
        @fqBankChange="fqBankChange"
        @fqNumChange="fqNumChange"
        v-track="{
          act: 'show',
          params: moduleExp(installmentType)
        }"
        :trackData="moduleBtnClickData(installmentType)"
      />
      <!-- 加购商品 -->
      <skuExtraProduct
        v-if="additionCommodityInfo.length && source != 21 && source != 20 && buyType == 1"
        :source="source"
      />
    </div>

    <SkuAction
      :spuInfo="spuInfo"
      :skuInfo="skuInfo"
      :checkedInfo="checkedInfo"
      :params="params"
      :floatTips="floatTips"
      :source="source"
      :hasRecommend="hasRecommend"
      :ordered="ordered"
      @clickTrack="clickTrack"
      @submit="submit"
      @showAppointment="showAppointment"
      @seeOther="seeOther"
      @goToRenew="goToRenew"
      @confirmSpec="confirmSpec"
    />
  </div>
</template>

<script>
import SkuProduct from './components/sku-product'
import SkuSpec from './components/sku-spec'
import SkuLaser from './components/sku-laser'
import SkuNumber from './components/sku-number'
import SkuSuite from './components/sku-suite'
import SkuService from './components/sku-service'
import SkuInstallment from './components/sku-installment'
import SkuAction from './components/sku-action'
import skuExtraProduct from './components/sku-extra-product'
import skuEventBus from '../sku-select/eventBus'
import SkuBuyType from './components/sku-buy-type'
import { vm as skuSelect } from '../sku-select/sku'
import { formatNumber } from 'utils/common'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'SkuSelect',
  props: {
    spuInfo: Object,
    skuInfo: Object,
    installment: {
      type: Object,
      default() {
        return {}
      }
    },
    params: {
      type: Object,
      default() {
        return {}
      }
    },
    floatTips: String,
    commonTrackData: {
      type: Object,
      default() {
        return {}
      }
    },
    hasRecommend: Boolean,
    ordered: {
      type: Boolean,
      default() {
        return false
      }
    },
    isWeChatApp: {
      type: Boolean,
      default() {
        return false
      }
    },
    hideBuyType: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  components: {
    SkuProduct,
    SkuSpec,
    SkuLaser,
    SkuNumber,
    SkuSuite,
    SkuService,
    SkuInstallment,
    SkuAction,
    SkuBuyType,
    skuExtraProduct
  },
  data() {
    return {
      number: 1, // 数量
      fqType: 0, // 分期类型
      fqBank: 0, // 分期银行code
      fqNum: 0, // 分期数
      laser: false, // 是否选中镭雕,
      suiteId: 0, // 选中的套餐Id
      service: {}, // 选中的服务
      name: '', // sku的规格名称组合，形如全网通版 8G+128G 极光幻境
      checkedSpecData: {}, // 选中的规格信息
      buyType: 1 // 购买类型1: 立即购买 2:以旧换新
    }
  },
  computed: {
    ...mapState('detailv3', ['isShowSkuSelect', 'spotEstimatedPrice', 'additionCommodityInfo']),
    ...mapGetters('detailv3', [
      'currentSuiteInfo',
      'extCode',
      'isLottery',
      'isServiceGoods',//服务宝商品
      'isMoYin',
      'showRecycleBuyType',
      'recycleSupplierId'
    ]),
    skuId() {
      return this.skuInfo?.commoditySkuBaseInfo.skuId
    },
    // 获取商品类型, 商品类型，1：手机 2：配件 3：服务 4：虚拟商品
    goodsType() {
      return this.spuInfo?.commoditySpu?.cmmdyTypeId
    },
    // 优惠类型 vip,group,deposit,fullpay,quickbuy,bigpromotion,normal
    // 分别对应 会员,拼团,定金,全款,抢购,大促,正常
    discountType() {
      return this.skuInfo?.commoditySkuDiscount?.commodityDiscountType || 'normal'
    },
    // sku选择弹层调起来源 1:已选模块;2:加入购物车;3:立即购买;4:领券购买;5:立即预约;6:一键拼团;7:立即秒杀;8:单独购买;9:镭雕;10:全款预定;11:定金预售;12:到货通知;13:仅作为赠品;14:商品已下架;15:去参团;16:快速参团;20:一站式换新弹层;21:首页一站式换新楼层)
    source() {
      let pos
      let text = this.skuInfo?.commoditySkuButton?.commodityMainButtonDesc || ''

      function has(str, target) {
        return str.indexOf(target) >= 0
      }
      if (has(text, '立即购买')) {
        pos = 3
      } else if (has(text, '领券购买')) {
        pos = 4
      } else if (has(text, '立即预约')) {
        pos = 5
      } else if (has(text, '全款预定')) {
        pos = 10
      } else if (has(text, '支付定金')) {
        pos = 11
      }

      // 优先取参数中的source
      return this.params?.source || pos
    },
    // 是否是拼团活动调起的弹层（活动类型为拼团，且调起位置不是单独购买
    isGroup() {
      return this.discountType == 'group' && this.params?.source != 8
    },
    // 当前sku的套餐集合
    suites() {
      return this.skuInfo?.commoditySkuDiscount?.commoditySuite
    },
    laserInfo() {
      return this.skuInfo?.commodityActivities?.find(item => item.actType == '2')
    },
    // 当前选中的套餐信息
    currentSuite() {
      if (this.suites && this.suites.length) {
        const suiteId = this.suiteId
        if (suiteId == 0) {
          return {
            id: 0,
            name: '官方标配',
            totalPrice: 0
          }
        } else {
          return this.suites.find(suite => suite.id == suiteId) || {}
        }
      }

      return {}
    },
    // 商品单价，单价*数量
    salePrice() {
      return this.skuInfo?.commoditySkuBaseInfo?.salePrice
    },
    singlePrice() {
      let price = 0
      let normalPrice = this.skuInfo?.commoditySkuBaseInfo?.salePrice
      let actPirce = this.skuInfo?.commoditySkuDiscount?.commodityDiscountPrice
      // 如果有活动价，则取活动价，现货购买不取活动价
      if (this.params?.isSpot) {
        price = normalPrice
      } else {
        price = actPirce || normalPrice
      }
      // 如果是拼团单独购买
      if (this.discountType == 'group' && this.source == 8) {
        price = normalPrice
      }

      // 如果是套餐，则不管是否抢购状态，都取套餐价
      if (this.currentSuite.id) {
        price = this.currentSuite.totalPrice
      }

      // 加上服务的价格
      Object.values(this.service).forEach(item => {
        if (item && item.salePrice) {
          price += item.salePrice
        }
      })

      return price
    },
    // 商品单价，单价*数量
    totalPrice() {
      return formatNumber(this.singlePrice * this.number)
    },
    // 最大购买限制
    maxNum() {
      // 一站式换新限制数量
      if (this.source == 20 || this.source == 21 || this.buyType == 2) {
        return 1
      }
      if (this.isServiceGoods || this.isMoYin) {
        return 1
      }
      return this.skuInfo?.commoditySkuBaseInfo?.perBuyLimit
    },
    // sku是否支持手动输入最大数量
    enableNumInput() {
      return this.skuInfo?.commoditySkuBaseInfo?.supportInputBoxes
    },
    // 选中的信息
    checkedInfo() {
      return {
        skuId: this.checkedSpecData?.skuId,
        number: this.number,
        fqType: this.fqType,
        fqBank: this.fqBank,
        fqNum: this.fqNum,
        laser: this.laser,
        currentSuite: this.currentSuite,
        service: this.service,
        name: this.checkedSpecData?.name,
        oldSkuId: this.checkedSpecData?.oldSkuId,
        buyType: this.buyType
      }
    },
    installmentType() {
      return this.installment?.selfInstallment ? '分期付款_含丰融分期' : '分期付款_不含丰融分期'
    }
  },
  watch: {
    params: {
      immediate: true,
      deep: true,
      handler(val) {
        // 从某些入口触发弹层时可能会携带选中参数，打开弹层后要默认选中
        if (val?.isShow) {
          setTimeout(() => {
            this.laserChange(!!val?.checked?.laser)
          }, 0)
        }
      }
    },
    isShowSkuSelect: {
      immediate: true,
      handler(val) {
        if (val) {
          // 根据source设置actIgnore,单独购买流程不关心活动
          if (this.source == 8) {
            skuSelect.actIgnore = true
          }
          // 曝光
          this.exposure()
        }
      }
    },
    'commonTrackData.sku_id': {
      handler(val) {
        val && this.isShowSkuSelect && this.exposure()
      }
    }
  },
  created() {
    // sku变化事件
    skuEventBus.$on('skuChange', specData => {
      if (specData.skuId == specData.oldSkuId) return // 新增相同skuId不重置信息【product/selects】
      this.resetCheckedItems()
    })
    // 选中项变化事件
    skuEventBus.$on('specChange', specData => {
      this.specChange(specData)
    })
    // 获取初始化信息
    this.checkedSpecData = skuSelect?.getInitData()?.checkedSpecData
    // 当链接上有套餐Id时，默认选中套餐,不能通过链接参数方式，因为进入页面切换版本再进入已选弹层时候，已经重置官方标配了，这里需要和外部商品名显示保持一致
    if (this.currentSuiteInfo?.id) {
      this.suiteChange(this.currentSuiteInfo.id)
    }
  },
  methods: {
    moduleData(pos) {
      // pos 1:购买方式;2:版本;3:颜色;4:免费定制;5:套餐;6:服务;7:分期付款（包含丰融分期）;8:分期付款（不包含丰融分期）
      return {
        sku_id: this.skuId,
        source_type: this.recycleSupplierId || '',
        activity_type: this.recycleSupplierId ? 2 : 1 ,
        source: this.source,
        module: pos
      }
    },
    moduleExp(pos) {
      // 模块曝光
      let data = this.moduleData(pos)
      data.event_id = '154|006|02|077'
      return data
    },
    moduleBtnClickData(pos) {
      // 模块内按钮点击
      let data = this.moduleData(pos)
      data.event_id = '154|006|01|077'
      return data
    },
    exposure() {
      // 组件曝光埋点
      this.$track({
        cfrom: '154|003|02|077',
        event_id: '154|003|02|077',
        page_name: this.commonTrackData.page_name,
        source: this.source,
        sku_id: this.commonTrackData.sku_id,
        ab_id: this.spuQuery?.abId || this.$route.query?.abId,
        source_type:this.recycleSupplierId||'',//##供应商id
        activity_type:this.recycleSupplierId?2:1//1:通用、2:换新,有供应商id时为换新场景
      })
    },
    // 获取选中数据，供外部调用
    getData() {
      return this.checkedInfo
    },
    //  切换规格项，如果切换的规格项可以组成新的sku，则向上通报skuChange事件
    specChange(specData) {
      // 记录选中数据
      this.checkedSpecData = specData
    },

    // 重置选中的信息
    resetCheckedItems() {
      // 重置套餐
      this.suiteId = 0
      // 重置分期数
      this.fqType = 0
      this.fqNum = 0
      // 重置数量
      this.number = 1
      // 重置镭雕
      this.laser = false
    },

    // 镭雕选中切换
    laserChange(isChecked) {
      this.laser = isChecked
      this.$emit('change', this.checkedInfo)
    },

    // 切换套餐
    suiteChange(suiteId = 0) {
      this.suiteId = suiteId
      // 切换套餐，选中数量重置为1
      this.number = 1
      this.$emit('change', this.checkedInfo)
    },

    // 修改数量
    numberChange(num) {
      this.number = num
      this.$emit('change', this.checkedInfo)
    },

    // 切换服务
    serviceChange(type, service) {
      // type 1 碎屏保， 2 延保， 3 后盖宝， 4 V享无忧（碎屏宝+后盖宝+延保）， 5 保值换新，6 意外保修， 7 焕新宝（保值换新+意外保修）， 8 电池换新，9 vivocare（意外保修+电池换新+延保）, 10 普通屏vivocare+, 11 折叠屏vivocare+， 0 取消所有
      if (type == 1) {
        this.serviceDelete([1, 4, 10, 11])
      } else if (type == 2) {
        this.serviceDelete([2, 4, 9, 10, 11])
      } else if (type == 3) {
        this.serviceDelete([3, 4])
      } else if (type == 4) {
        this.serviceDelete([1, 2, 3, 4, 9, 10, 11])
      } else if (type == 5) {
        this.serviceDelete([5, 7, 10, 11])
      } else if (type == 6) {
        this.serviceDelete([6, 7, 9, 10, 11])
      } else if (type == 7) {
        this.serviceDelete([5, 6, 7, 9, 10, 11])
      } else if (type == 8) {
        this.serviceDelete([8, 9, 10, 11])
      } else if (type == 9) {
        this.serviceDelete([2, 4, 6, 7, 8, 9, 10, 11])
      } else if (type == 10) {
        this.serviceDelete([1, 2, 4, 5, 6, 7, 8, 9, 10, 11])
      } else if (type == 11) {
        this.serviceDelete([1, 2, 4, 5, 6, 7, 8, 9, 10, 11])
      }
      if (type == 0) {
        this.service = {}
      } else {
        this.$set(this.service, type, service)
      }
      this.$nextTick(() => {
        this.$emit('change', this.checkedInfo)
      })
    },
    serviceDelete(arr) {
      for (let i = 0; i < arr.length; i++) {
        this.$delete(this.service, arr[i])
      }
    },
    fqTypeChange(type) {
      this.fqType = this.fqType == type ? 0 : type
      if (!this.fqType) {
        this.fqNum = 0
      }
      this.$emit('change', this.checkedInfo)
    },
    fqBankChange(code) {
      this.fqBank = this.fqBank == code ? 0 : code
    },
    // 切换分期
    fqNumChange(num) {
      this.fqNum = num
      this.$emit('change', this.checkedInfo)
    },
    // 切换购买方式
    buyTypeChange(type) {
      this.buyType = type
      this.$emit('change', this.checkedInfo)
    },
    // 根据已选的规格项判断是否能组成完整的sku
    isSku() {
      return this.specMain.every(specId => !!(this.checkedSpecItem[specId] && this.checkedSpecItem[specId].id))
    },
    // 提交
    submit(data) {
      this.$emit('submit', data)
    },
    // 查看推荐商品
    seeOther() {
      this.$emit('seeOther')
    },
    goToRenew() {
      this.$emit('goToRenew', { trackFrom: 4 }) // 商详页已选弹层
    },
    confirmSpec() {
      this.$emit('confirmSpec')
    },
    showAppointment(isShow) {
      this.$emit('showAppointment', isShow)
    },
    beforeClose() {
      // 如果是单独购买场景，则重置数量，镭雕，套餐
      if (this.source == 8) {
        this.number = 1
        this.laser = false
        this.suiteId = 0
        this.$emit('change', this.checkedInfo)
      }
      // 关闭之前重置actIgnore
      skuSelect.actIgnore = false
    },
    // 点击埋点
    clickTrack(text) {
      let contentModel = [
        '商品主图', // 1
        '立即购买', // 2
        '添加赠言', // 3
        '分期购买', // 4
        '支付定金', // 5
        '全款预定', // 6
        '一键开团', // 7
        '原价购买', // 8
        '查看推荐商品', // 9 下架
        '查看推荐商品', // 10 售罄
        '预约', // 11
        '到货通知', // 12
        '确定', // 13
        '加入购物车', // 14
        '-',
        '立即换新' // 16
      ]
      let enumVal = contentModel.findIndex(item => text.indexOf(item) > -1) + 1
      if (this.isLottery) {
        enumVal = 15 // 一分团一键开团
      } else if (enumVal == 9) {
        enumVal = this.extCode == 4 ? 9 : 10
      }
      this.$track({
        cfrom: '154|003|01|077',
        event_id: '154|003|01|077',
        page_name: this.commonTrackData.page_name,
        source: this.source,
        sku_id: this.commonTrackData.sku_id,
        ab_id: this.spuQuery?.abId || this.$route.query?.abId,
        parameter_content: enumVal || 13,
        source_type:this.recycleSupplierId||'',
        activity_type:this.recycleSupplierId?2:1//1:通用、2:换新,有供应商id时为换新场景
      })
    },
    // 重置参数
    reInitSkuSpecSelect(skuId) {
      this.$refs.skuSpecRef?.reInitSkuSpecSelect(skuId)
    },
    // 重置参数
    reInitSkuParamsSelect({ fqNum, currentSuite, service }) {
      this.fqNum = fqNum
      this.suiteId = currentSuite.id || 0 // 到手价氛围的判断suiteId必须为0，undefined判断为false不展示氛围
      this.service = service
    }
  }
}
</script>

<style lang="scss" src="./index.scss"></style>
